import { isFunction, omitBy } from 'lodash';

/**
 * Returns a shallow copy of the given state without computed properties or functions.
 */
export const extractInitialState = <T>(state: T): T => {
  return omitBy(
    state as object,
    (value, key) => isFunction(value) || key === 'computed',
  ) as T;
};
